export const GOOGLE_MAPS_KEY = 'AIzaSyBcvQyTwx5Z_o5SJayg4cEakukymRYvEo4'